import { Fraction } from "fractional";

const idx_data_hole_sizesRAW = [];

let order = 0;
let i = 0;
let d = 1;

idx_data_hole_sizesRAW.push({
  size: "---",
  decimal: 0,
  order_idx: -1,
});

for (let j = 0; j <= 1; j++) {
  if (j > 0) {
    i = j;
  } else {
    i = "";
  }

  if (i == 1) {
    d = 0;

    idx_data_hole_sizesRAW.push({
      size: i + "",
      decimal: i + d * (1 / 64),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_hole_sizesRAW.push({
      size: (i + " 1/64").trim(),
      decimal: i + d * (1 / 64),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_hole_sizesRAW.push({
      size: (i + " 1/32").trim(),
      decimal: i + d * (1 / 64),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_hole_sizesRAW.push({
      size: (i + " 3/64").trim(),
      decimal: i + d * (1 / 64),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_hole_sizesRAW.push({
      size: (i + " 1/16").trim(),
      decimal: i + d * (1 / 64),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_hole_sizesRAW.push({
      size: (i + " 5/64").trim(),
      decimal: i + d * (1 / 64),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_hole_sizesRAW.push({
      size: (i + " 3/32").trim(),
      decimal: i + d * (1 / 64),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_hole_sizesRAW.push({
      size: (i + " 7/64").trim(),
      decimal: i + d * (1 / 64),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_hole_sizesRAW.push({
      size: (i + " 1/8").trim(),
      decimal: i + d * (1 / 64),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_hole_sizesRAW.push({
      size: (i + " 9/64").trim(),
      decimal: i + d * (1 / 64),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_hole_sizesRAW.push({
      size: (i + " 5/32").trim(),
      decimal: i + d * (1 / 64),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_hole_sizesRAW.push({
      size: (i + " 11/64").trim(),
      decimal: i + d * (1 / 64),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_hole_sizesRAW.push({
      size: (i + " 3/16").trim(),
      decimal: i + d * (1 / 64),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_hole_sizesRAW.push({
      size: (i + " 13/64").trim(),
      decimal: i + d * (1 / 64),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_hole_sizesRAW.push({
      size: (i + " 7/32").trim(),
      decimal: i + d * (1 / 64),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_hole_sizesRAW.push({
      size: (i + " 15/64").trim(),
      decimal: i + d * (1 / 64),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_hole_sizesRAW.push({
      size: (i + " 1/4").trim(),
      decimal: i + d * (1 / 64),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_hole_sizesRAW.push({
      size: (i + " 17/64").trim(),
      decimal: i + d * (1 / 64),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_hole_sizesRAW.push({
      size: (i + " 9/32").trim(),
      decimal: i + d * (1 / 64),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_hole_sizesRAW.push({
      size: (i + " 19/64").trim(),
      decimal: i + d * (1 / 64),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_hole_sizesRAW.push({
      size: (i + " 5/16").trim(),
      decimal: i + d * (1 / 64),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_hole_sizesRAW.push({
      size: (i + " 21/64").trim(),
      decimal: i + d * (1 / 64),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_hole_sizesRAW.push({
      size: (i + " 11/32").trim(),
      decimal: i + d * (1 / 64),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_hole_sizesRAW.push({
      size: (i + " 23/64").trim(),
      decimal: i + d * (1 / 64),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_hole_sizesRAW.push({
      size: (i + " 3/8").trim(),
      decimal: i + d * (1 / 64),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_hole_sizesRAW.push({
      size: (i + " 25/32").trim(),
      decimal: i + d * (1 / 64),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_hole_sizesRAW.push({
      size: (i + " 13/32").trim(),
      decimal: i + d * (1 / 64),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_hole_sizesRAW.push({
      size: (i + " 27/64").trim(),
      decimal: i + d * (1 / 64),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_hole_sizesRAW.push({
      size: (i + " 7/16").trim(),
      decimal: i + d * (1 / 64),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_hole_sizesRAW.push({
      size: (i + " 29/64").trim(),
      decimal: i + d * (1 / 64),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_hole_sizesRAW.push({
      size: (i + " 15/32").trim(),
      decimal: i + d * (1 / 64),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_hole_sizesRAW.push({
      size: (i + " 31/64").trim(),
      decimal: i + d * (1 / 64),
      order_idx: order,
    });
    order++;
    d++;
  }

  d = 32;
  idx_data_hole_sizesRAW.push({
    size: (i + " 1/2").trim(),
    decimal: i + d * (1 / 64),
    order_idx: order,
  });
  order++;
  d++;

  if (i == 0) {
    idx_data_hole_sizesRAW.push({
      size: (i + " 33/64").trim(),
      decimal: i + d * (1 / 64),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_hole_sizesRAW.push({
      size: (i + " 17/32").trim(),
      decimal: i + d * (1 / 64),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_hole_sizesRAW.push({
      size: (i + " 35/64").trim(),
      decimal: i + d * (1 / 64),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_hole_sizesRAW.push({
      size: (i + " 9/16").trim(),
      decimal: i + d * (1 / 64),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_hole_sizesRAW.push({
      size: (i + " 37/64").trim(),
      decimal: i + d * (1 / 64),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_hole_sizesRAW.push({
      size: (i + " 19/32").trim(),
      decimal: i + d * (1 / 64),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_hole_sizesRAW.push({
      size: (i + " 39/64").trim(),
      decimal: i + d * (1 / 64),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_hole_sizesRAW.push({
      size: (i + " 5/8").trim(),
      decimal: i + d * (1 / 64),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_hole_sizesRAW.push({
      size: (i + " 41/64").trim(),
      decimal: i + d * (1 / 64),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_hole_sizesRAW.push({
      size: (i + " 21/32").trim(),
      decimal: i + d * (1 / 64),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_hole_sizesRAW.push({
      size: (i + " 43/64").trim(),
      decimal: i + d * (1 / 64),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_hole_sizesRAW.push({
      size: (i + " 11/16").trim(),
      decimal: i + d * (1 / 64),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_hole_sizesRAW.push({
      size: (i + " 45/64").trim(),
      decimal: i + d * (1 / 64),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_hole_sizesRAW.push({
      size: (i + " 23/32").trim(),
      decimal: i + d * (1 / 64),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_hole_sizesRAW.push({
      size: (i + " 47/64").trim(),
      decimal: i + d * (1 / 64),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_hole_sizesRAW.push({
      size: (i + " 3/4").trim(),
      decimal: i + d * (1 / 64),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_hole_sizesRAW.push({
      size: (i + " 49/64").trim(),
      decimal: i + d * (1 / 64),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_hole_sizesRAW.push({
      size: (i + " 25/32").trim(),
      decimal: i + d * (1 / 64),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_hole_sizesRAW.push({
      size: (i + " 51/64").trim(),
      decimal: i + d * (1 / 64),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_hole_sizesRAW.push({
      size: (i + " 13/16").trim(),
      decimal: i + d * (1 / 64),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_hole_sizesRAW.push({
      size: (i + " 53/64").trim(),
      decimal: i + d * (1 / 64),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_hole_sizesRAW.push({
      size: (i + " 27/32").trim(),
      decimal: i + d * (1 / 64),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_hole_sizesRAW.push({
      size: (i + " 55/64").trim(),
      decimal: i + d * (1 / 64),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_hole_sizesRAW.push({
      size: (i + " 7/8").trim(),
      decimal: i + d * (1 / 64),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_hole_sizesRAW.push({
      size: (i + " 57/64").trim(),
      decimal: i + d * (1 / 64),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_hole_sizesRAW.push({
      size: (i + " 29/32").trim(),
      decimal: i + d * (1 / 64),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_hole_sizesRAW.push({
      size: (i + " 59/64").trim(),
      decimal: i + d * (1 / 64),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_hole_sizesRAW.push({
      size: (i + " 15/16").trim(),
      decimal: i + d * (1 / 64),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_hole_sizesRAW.push({
      size: (i + " 61/64").trim(),
      decimal: i + d * (1 / 64),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_hole_sizesRAW.push({
      size: (i + " 31/32").trim(),
      decimal: i + d * (1 / 64),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_hole_sizesRAW.push({
      size: (i + " 63/64").trim(),
      decimal: i + d * (1 / 64),
      order_idx: order,
    });
    order++;
    d++;
  }
}

export const idx_data_hole_sizes = idx_data_hole_sizesRAW.map((size) => {
  const fraction = new Fraction(size.size);
  return {
    ...size,
    decimal: (fraction.numerator / fraction.denominator).toFixed(3),
  };
});
